// extracted by mini-css-extract-plugin
module.exports = {"exportDocumentConfigurationDetails":"details_exportDocumentConfigurationDetails__64KBX","item":"details_item__3HOT0"};